import { IAclFilter } from "../../store/queries/acl-filter.interface";
import { Account } from "../account/account.model";
import { dictionarySelector, listSelector } from "../query-facade";
import { createSelector } from "reselect";
import { isInArray } from "../../../core/util/is-in-array";
import { AclFilter } from "../../store/queries/acl-filter";
import { AppConfig } from "../../../app/app.config";

export class AccountAclFilter extends AclFilter<Account> implements IAclFilter<Account> {

    protected _validAccountIds: listSelector<string>;

    createSelector(idsSelector: listSelector<string>, entitiesSelector: dictionarySelector<Account>): listSelector<Account> {
        return createSelector(
            idsSelector,
            entitiesSelector,
            this.validAccountIds(),
            (ids, entities, validIds) => {
                AppConfig.debugQueries && console.log("AccountAclFilter executing", entities);
                return ids.map(id => entities[id])
                    .filter(account => isInArray(account.id, validIds));
            }
        );
    }

    protected validAccountIds(): listSelector<string> {

        if (!this._validAccountIds) {

            this._validAccountIds = createSelector(
                this.memberships,
                this.selectedUserId,
                (memberships, userId) => {
                    return memberships
                        .filter(membership => membership.user === userId)
                        .map(membership => membership.account);
                });
        }

        return this._validAccountIds;
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account-object/account.acl-filter.ts